import { TasksTable } from "@/features/tasks/tasks-table";

export function TasksScreen() {
  return (
    <div className="p-4">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Tasks</h1>
        <p className="text-gray-600 mt-2">
          Manage individual pickup and delivery tasks
        </p>
      </div>
      <TasksTable />
    </div>
  );
}
